/* eslint-disable import/prefer-default-export */
import get from 'lodash/get';

export function getSizeType(creative, productId) {
  const productInContext = creative.products.compatibleProducts.find(
    p => p.id === productId,
  );
  return get(productInContext, 'creativeRequirement.sizeType', '-');
}
